import { render, staticRenderFns } from "./InvoiceDashboard.vue?vue&type=template&id=2837ba96&scoped=true&"
import script from "./InvoiceDashboard.vue?vue&type=script&lang=js&"
export * from "./InvoiceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDashboard.vue?vue&type=style&index=0&id=2837ba96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2837ba96",
  null
  
)

export default component.exports